export const LOCAL_JOBS_FIRST_DISTANCE = 50;
